var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#242938;}\r\n\t.st1{fill:#00D8FF;}\r\n\t.st2{fill:none;stroke:#00D8FF;stroke-width:1.6708;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.2,0h25.5C43,0,48,5,48,11.2v25.5C48,43,43,48,36.8,48H11.2C5,48,0,43,0,36.8V11.2C0,5,5,0,11.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24,27.6c1.9,0,3.5-1.6,3.5-3.5s-1.6-3.5-3.5-3.5c-1.9,0-3.5,1.6-3.5,3.5S22.1,27.6,24,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24,16.9c4.7,0,9.1,0.7,12.3,1.8c4,1.4,6.4,3.4,6.4,5.3c0,2-2.6,4.1-6.8,5.6c-3.2,1.1-7.5,1.6-11.9,1.6 c-4.6,0-8.9-0.5-12.2-1.6c-4.1-1.4-6.6-3.6-6.6-5.5c0-1.9,2.3-3.9,6.2-5.3C14.8,17.6,19.3,16.9,24,16.9L24,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.8,20.5c2.3-4.1,5.1-7.5,7.7-9.8c3.2-2.8,6.2-3.8,7.8-2.9c1.7,1,2.3,4.3,1.4,8.7c-0.7,3.3-2.3,7.3-4.5,11.1 c-2.3,4-4.9,7.4-7.5,9.7c-3.3,2.9-6.4,3.9-8.1,2.9c-1.6-0.9-2.2-4-1.5-8C13.8,28.8,15.4,24.6,17.8,20.5L17.8,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.8,27.7c-2.4-4.1-4-8.2-4.6-11.6C12.4,12,13,8.8,14.6,7.9c1.7-1,4.9,0.2,8.2,3.1c2.5,2.3,5.1,5.6,7.4,9.5 c2.3,4,4,8,4.7,11.3c0.8,4.3,0.2,7.5-1.5,8.5c-1.6,0.9-4.5-0.1-7.7-2.8C23,35.3,20.2,31.8,17.8,27.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.eb3960284b2b9f318a5f5dd826af3873.svg";
export { ForwardRef as ReactComponent };